import React from "react";
import Svg from "../../../components/Svg/Svg";
import { SvgProps } from "../../../components/Svg/types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 9 17" {...props}>
      <path d="M7.59935 5.65768H5.65768V4.0412C5.65768 3.2077 5.72714 2.68045 6.92055 2.68045H7.62145C8.06977 2.68045 8.42969 2.32053 8.42969 1.87221V0.858755C8.42969 0.435692 8.10765 0.0757725 7.68459 0.0473578C7.19523 0.0157859 6.70902 0 6.2165 0C4.02541 0 2.42472 1.33865 2.42472 3.7981V5.65768H0.80824C0.363076 5.65768 0 6.02075 0 6.46592V8.0824C0 8.52756 0.363076 8.89064 0.80824 8.89064H2.42472V15.3566C2.42472 15.8017 2.7878 16.1648 3.23296 16.1648H4.84944C5.2946 16.1648 5.65768 15.8017 5.65768 15.3566V8.88748H7.41623C7.82666 8.88748 8.1708 8.57808 8.21816 8.1708L8.40127 6.55748C8.4581 6.07758 8.0824 5.65768 7.59935 5.65768Z" />
    </Svg>
  );
};

export default Icon;
